/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  DeletePaymentReviewRecordsRequest,
  DeletePaymentReviewRecordsResponse,
  DownloadPaymentReviewsRequest,
  DownloadPaymentReviewsResponse,
  PaymentReviewRetryRequest,
  PaymentReviewRetryResponse,
  PaymentReviewsRetryRequest,
  PaymentReviewsRetryResponse,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Download payment review results.
 */
export const getPaymentReviewResultsFileContent = (
  downloadPaymentReviewsRequest: DownloadPaymentReviewsRequest,
  options?: SecondParameter<
    typeof backofficeRequest<DownloadPaymentReviewsResponse>
  >,
) => {
  return backofficeRequest<DownloadPaymentReviewsResponse>(
    {
      url: `/payment-reviews/download`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: downloadPaymentReviewsRequest,
    },
    options,
  )
}
/**
 * @summary Retry payment review records by IDs
 */
export const retryPaymentReviewRecordsById = (
  paymentReviewsRetryRequest: PaymentReviewsRetryRequest,
  options?: SecondParameter<
    typeof backofficeRequest<PaymentReviewsRetryResponse>
  >,
) => {
  return backofficeRequest<PaymentReviewsRetryResponse>(
    {
      url: `/payment-reviews/retry`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: paymentReviewsRetryRequest,
    },
    options,
  )
}
/**
 * @summary Delete payment review records by ID
 */
export const deletePaymentReviewRecordByIds = (
  deletePaymentReviewRecordsRequest: DeletePaymentReviewRecordsRequest,
  options?: SecondParameter<
    typeof backofficeRequest<DeletePaymentReviewRecordsResponse>
  >,
) => {
  return backofficeRequest<DeletePaymentReviewRecordsResponse>(
    {
      url: `/payment-reviews/records`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: deletePaymentReviewRecordsRequest,
    },
    options,
  )
}
/**
 * @summary Retry payment reviews
 */
export const retryPaymentReviewRecordsByFilters = (
  id: number,
  paymentReviewRetryRequest: PaymentReviewRetryRequest,
  options?: SecondParameter<
    typeof backofficeRequest<PaymentReviewRetryResponse>
  >,
) => {
  return backofficeRequest<PaymentReviewRetryResponse>(
    {
      url: `/payment-reviews/${id}/retry`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: paymentReviewRetryRequest,
    },
    options,
  )
}
export type GetPaymentReviewResultsFileContentResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentReviewResultsFileContent>>
>
export type RetryPaymentReviewRecordsByIdResult = NonNullable<
  Awaited<ReturnType<typeof retryPaymentReviewRecordsById>>
>
export type DeletePaymentReviewRecordByIdsResult = NonNullable<
  Awaited<ReturnType<typeof deletePaymentReviewRecordByIds>>
>
export type RetryPaymentReviewRecordsByFiltersResult = NonNullable<
  Awaited<ReturnType<typeof retryPaymentReviewRecordsByFilters>>
>
